import type { AssistantModelMessage, ToolModelMessage, UIMessage } from 'ai';

import type { UIMessageWithMetadata } from './types';
import type { GetChatWithMessagesMessage } from '../queries/chats';

type ResponseMessageWithoutId = ToolModelMessage | AssistantModelMessage;
type ResponseMessage = ResponseMessageWithoutId & { id: string };

export function getMostRecentUserMessage(messages: Array<UIMessage>) {
  const userMessages = messages.filter((message) => message.role === 'user');
  return userMessages.at(-1);
}

export function getTrailingMessageId({ messages }: { messages: Array<ResponseMessage> }): string | null {
  const trailingMessage = messages.at(-1);

  if (!trailingMessage) return null;

  return trailingMessage.id;
}

export function sanitizeText(text: string) {
  return text.replace('<has_function_call>', '');
}

export function getChatPlaceholder(accountName?: string, programType?: string): string {
  if (!accountName || !programType) {
    return 'How can I help you today?';
  }

  if (programType === 'PROPERTY_AND_CASUALTY') {
    return `Ask me about ${accountName}'s policies, coverage limits, or renewal dates...`;
  }

  if (programType === 'EMPLOYEE_BENEFITS') {
    return `Ask me about ${accountName}'s plans, rates, contributions, or enrollment details...`;
  }

  return 'How can I help you today?';
}

/** Vercel AI SDK uses ID, backend uses uuid */
export function backendMessageToSDKMessage(message: GetChatWithMessagesMessage): UIMessageWithMetadata {
  return {
    ...message,
    id: message.uuid!,
    // createdAt: message.createdAt ? new Date(message.createdAt) : undefined,
    role: message.role as UIMessage['role'],
    // TODO: Check if possible to not cast to SDKMessage['parts']
    parts: message.parts ? (message.parts as UIMessageWithMetadata['parts']) : [],

    metadata: {
      reaction: message.reaction,
      files:
        message.files?.map((file) => ({
          uuid: file.uuid!,
          filename: file.filename,
        })) ?? [],
    },
  };
}

/**
 * Check if a chat is new (no UUID or no messages)
 */
export function isNewChat(chatUuid?: string): boolean {
  return !chatUuid;
}
